let dev = process.env.NODE_ENV !== 'production'
let host = dev ? 'http://192.168.31.233:20210' : 'https://wx.fanboshi.net';
const url = host
export {
    host,
    url,
}